import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { DigisubservicesService } from '../services/digisubservices.service';
import { EncdecriptService } from '../services/encdecrypt.service';

@Component({
  selector: 'app-admin-registration',
  templateUrl: './admin-registration.component.html',
  styleUrl: './admin-registration.component.scss'

})
export class AdminRegistrationComponent {

  roles: any[] = [];
  departments: any[] = [];

  userForm = this.fb.group({
    username: ['', Validators.required],
    password: ['', Validators.required],
    mobile: ['', Validators.required],
    role: [this.roles[0], Validators.required],
    department: [this.departments[0], Validators.required]
  });

  ngOnInit(): void {
    this.loadDepartmentsData();
    this.loadRolesData();
  }

  constructor(private fb: FormBuilder, private service: DigisubservicesService, public decryptService: EncdecriptService) {

    this.userForm = this.fb.group({
      username: [''],
      password: [''],
      mobile: [''],
      role: [''],        // must be '' so placeholder shows
      department: ['']   // must be '' so placeholder shows
    });

  }


  loadDepartmentsData() {
    this.service.getdept().subscribe({
      next: (data) => {
        console.log('Departments:', data);
        this.departments = data;
      },
      error: (err) => {
        console.error('Error loading departments:', err);
      }
    });
  }

  loadRolesData() {
    this.service.getRolesData().subscribe({
      next: (data) => {
        console.log('Roles:', data);
        this.roles = data;
      },
      error: (err) => {
        console.error('Error loading roles:', err);
      }
    });
  }

  addUser() {
    if (this.userForm.invalid) return;

    const loginData = { ...this.userForm.value };
    const secretKey = '123456$#@$^@1ERF';

    // Encrypt entered password
    loginData.password = this.decryptService.set(secretKey, loginData.password);

    this.service.addNewUser(loginData)
      .subscribe({
        next: (res: any) => {
          if (res.status === 'success') {
            alert(res.message);
            this.userForm.reset();
          } else {
            alert('Error: ' + res.message);
          }
        },
        error: (err) => {
          console.error(err);
          alert('Something went wrong!');
        }
      });
  }

}
